// import { Document, Page, pdfjs } from 'react-pdf';
import React, { useState, useEffect } from 'react';
import StudentTemplate from '../../component/StudentTemplate';
import PDFViewer from '../../component/Pdfview.js';
import { ToastContainer, toast } from 'react-toastify';
import '../../Assets/css/responsiveptable.css';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Api from '../../component/Api';
import Select from 'react-select';
import Loader from '../../component/Loader.js';
import logo from "../../Assets/images/gif/danger.gif";



// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;





const StudentEPaperCopyview = () => {

    const navigate = useNavigate();
    const isAuth = useAuth();

    if (isAuth === false) {
        navigate("/")
    }

    const { http } = Api();
    const [tableData, setTableData] = useState([]);
    // const [containerClass, setContainerClass] = useState("my-page");
    const [loading, setLoading] = useState(false);
    const [selectedExamId, setExamId] = useState([]);
    const [examId, setSelectedExamId] = useState(false);
    const [getexamData, setExamData] = useState([]);
    const [selectedScrutiny, setSelectedScrutiny] = useState([]);
    const [selectedRevaluation, setSelectedRevaluation] = useState([]);
    const [selectedEcopy, setSelectedEcopy] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [isExpanded, setIsExpanded] = useState(false);
    const [isReExpanded, setIsReExpanded] = useState(false);
    const [SCRUTINY_COST, setSCRUTINY_COST] = useState(0);
    const [REVALUVATION_COST, setREVALUVATION_COST] = useState(0);
    const [ECOPY_COST, setECOPY_COST] = useState(0);


    const [url, setUrl] = useState(null);
    const [examlink, setExamlink] = useState(null);
    const [ispaymentcompleted, setIspaymentcompleted] = useState(false);
    const [isRevaluvationpaymentcompleted, setIsRevaluvationpaymentcompleted] = useState(false);

    const [activerevaluvation, setActiverevaluvation] = useState(false);

    const [steps, setSteps] = useState([]);
    const [isecopyopen, setIsecopyopen] = useState(false);


    const [pdfUrl, setPdfUrl] = useState(null);
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [selectedCourseName, setSelectedCourseName] = useState(null);
    const [selectedCourseCode, setSelectedCourseCode] = useState(null);
    const [remarkOfStudentData, setRemarkOfStudentData] = useState([]);
    const [scrutinyModalOpen, setScrutinyModalOpen] = useState(false);
    const [scrutinyRemark, setScrutinyRemark] = useState('');
    const [scrutinyCourseCode, setScrutinyCourseCode] = useState('');



    const handleOpenModal = (courseid, coursecode, coursename) => {

        http.get(`/Student/getScrutinyComplaintRemarksOfStudents`, {
            params: {
                examid: selectedExamId[0].value,
                course_id: courseid
            }
        }).then(response => {
            //setRemarkOfStudentData(response.data.result);
            const transformedData = response.data.result.map(item => ({
                ...item,
                questions_not_valued: item.questions_not_valued ? item.questions_not_valued.split(",") : [],
            }));
            setRemarkOfStudentData(transformedData);
            setSelectedCourseName(coursename);
            setSelectedCourseCode(coursecode);
            setIsModalOpen(true);

        }).catch(error => {
            // console.error("Error fetching scrutiny complaints:", error);
        });
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);

    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest(".modal-content")) {
                handleCloseModal();
            }
        };
        if (isModalOpen) {
            document.addEventListener("click", handleClickOutside);
        }
        return () => document.removeEventListener("click", handleClickOutside);
    }, [isModalOpen]);

    useEffect(() => {

        http.get(`getActiveEventsForStudents`, { params: { event_id: 14, exam_id: selectedExamId[0]?.value } })
            .then(response => {
                if (response.data.http_status === 500) {
                    setActiverevaluvation(false);
                }
                else {
                    // Find if there's any matching exam with active status
                    const matchingEvent = response.data.find(event =>
                        event.exam_id == selectedExamId[0].value && event.status === 'active'
                    );

                    if (matchingEvent) {
                        setActiverevaluvation(true);
                    } else {
                        setActiverevaluvation(false);
                    }
                }
            }).catch(error => {
                // console.error("Error in get active events:", error);
            });

        // http.get(`getActiveEventsForStudents`, { params: { event_id: 15, exam_id: selectedExamId[0]?.value } })
        //     .then(response => {

        //         if (response.data.http_status === 500) {
        //             setIsecopyopen(false);
        //         }
        //         else {
        //             const status = response.data[0].status;

        //             const examid = response.data[0].exam_id;
        //             if (status == 'active' && examid == selectedExamId[0].value) {
        //                 // console.log("iam here", response.data[0].status, response.data[0].exam_id);

        //             }
        //             else {
        //                 //  console.log("iam outside", response.data[0].status, response.data[0].exam_id);
        //                 setIsecopyopen(false);
        //             }
        //         }

        //     }).catch(error => {
        //         // console.error("Error in get active events:", error);

        //     });

        setIsecopyopen(true);

        console.log("isecopyopen", isecopyopen);

    }, [selectedExamId])


    const [isFirstSubmit, setFirstSubmit] = useState(false);

    // console.log("tableData", tableData);
    // console.log("tableDatalength=", tableData.length);

    useEffect(() => {
        const fetchFeeAndExamData = async () => {
            try {

                const feeResponse = await http.get(`Student/getRevaluationFee`);
                setECOPY_COST(feeResponse.data.ecopy_fee);
                setSCRUTINY_COST(feeResponse.data.scrutiny_fee);
                setREVALUVATION_COST(feeResponse.data.reval_fee);


                const examResponse = await http.get(`/Student/getActiveRevaluvationsStudent`);
                const exid = Number(localStorage.getItem('exam_id'));

                if (exid) {
                    const filteredExam = examResponse.data.activeexam
                        .filter((exam) => exam.examid === exid)
                        .map((exam) => ({
                            value: exam.examid,
                            label: exam.examtitle,
                        }));

                    setExamId(filteredExam);
                }

                setExamData(examResponse.data.activeexam);

            } catch (error) {

                const status = error.response?.data?.http_status;
                const message = error.response?.data?.message || "Something went wrong";

                if (status === 401 && error.response?.data?.status_code === "ERR9") {
                    toast.error("Invalid Token");
                    setTimeout(() => navigate("/"), 5000);
                } else if (status === 429 && error.response?.data?.status_code === "ERR33") {
                    toast.error(message);
                } else if (status === 500 && error.response?.data?.status_code === "ERR5") {
                    toast.error("No active exam found");
                } else {
                    toast.error(message);
                }
            }
        };

        fetchFeeAndExamData();
    }, []);

    useEffect(() => {

        const getScrutinyStatusOfStudents = (id) => {

            http.get('/Student/getScrutinyStatusOfStudents', {
                params: {
                    exam_id: id
                }
            }).then(response => {

                if (response.data.status_code === 'ERR5' && response.data.applied_status === 'Not Completed') {
                    const latestEncodedId = btoa(id);

                    navigate(`/scrutinycomplaints/${latestEncodedId}`);
                }
            }).catch(error => {

                // console.log("no respond");
            })

        }



        if (selectedExamId && selectedExamId.length > 0) {
            getScrutinyStatusOfStudents(selectedExamId[0].value);
        }



    }, [selectedExamId]);




    const handleChangeExam = (selectedOption) => {
        const selectedValue = selectedOption.value;
        setSelectedExamId(selectedValue);

        if (!selectedExamId.length || selectedOption.value !== selectedExamId[0].value) {
            setExamId([selectedOption]);
            setSelectedScrutiny([]);
            setSelectedRevaluation([]);
            setSelectedEcopy([]);
            setTotalAmount(0);
            setIsRevaluvationpaymentcompleted(false);
            setIspaymentcompleted(false);
        }

    }

    useEffect(() => {



        if (selectedExamId.length > 0) {



            http.get('/Student/getStudentRevaluationDetails', {
                params: { examid: selectedExamId[0].value },
            }).then(response => {

                const apiData = Array.isArray(response.data.result) ? response.data.result : [];
                const mappedData = apiData.map((item) => ({

                    credits: item.credit || "-",
                    course: item.course_name || "-",
                    coursecd: item.course_code || "-",
                    courseid: item.course_id || "-",

                    theory: {

                        cca: item.normalised_TI || "-",
                        ccaMax: item.normalised_TI_MAX || "-",
                        ese: item.normalised_TE || "-",
                        eseMax: item.normalised_TE_MAX || "-",
                        total: item.T_Total || "-",
                        max: item.normalised_T_Max || "-",
                        theory_result: item.theory_result || "-",
                    },

                    totalSecured: item.Total_Mark || "-",
                    maxMarks: item.Total_Mark_Max || "-",
                    grade: item.grade || "-",
                    gradePoints: item.GP || "-",
                    acquiredCredits: item.acquired_credit || "-",
                    creditPoint: item.credit_point || "-",
                    overallResult: item.result || "-",
                    txn_status: item.ecopy_txn_status || "-",
                    reval_txn_status: item.reval_txn_status || "-",
                    reval_txnid: item.reval_txnid || "-",
                    rv_result_status: item.rv_result_status || "-",
                    scrutiny: item.scrutiny || "-",
                    revaluation: item.revaluation || "-",
                    ecopy_status: item.ecopy_status || "-",
                    file_status: item.file_status || "-",
                    scrutiny_status: item.scrutiny_status || "-",
                    scrutiny_remarks: item.scrutiny_remarks || "-",
                    processing_step: item.processing_step || "-",
                    result_published: item.result_published || "-",
                    result_published_nochange: item.result_published_nochange || "-",
                    revaluation_result_published: item.revaluation_result_published || "-",


                }));

                let newScrutinyItems = [];
                let newRevaluationItems = [];
                let newEcopyItems = [];
                let totalAmountChange = 0;

                const hasStatus2 = mappedData.some(item => item.txn_status === 2);

                const hasStatus3 = mappedData.some(item => item.reval_txn_status === 2);

                // console.log("hasStatus3", hasStatus3);



                for (const item of mappedData) {
                    if (hasStatus2) {

                        if (item.txn_status === 2) {

                            newEcopyItems.push(item);
                            setIspaymentcompleted(true);
                        }
                    } else {

                        if (item.txn_status === 1 || item.txn_status === 3) {
                            newEcopyItems.push({
                                courseCode: item.coursecd,
                                courseName: item.course,
                                courseid: item.courseid
                            });

                            totalAmountChange = totalAmountChange + ECOPY_COST

                        }
                    }
                }

                for (const item of mappedData) {



                    if ((item.reval_txn_status === 1 || item.reval_txn_status === 3) && item.revaluation === 1) {
                        newRevaluationItems.push({
                            courseCode: item.coursecd,
                            courseName: item.course,
                            courseid: item.courseid,

                        });

                        totalAmountChange = totalAmountChange + REVALUVATION_COST

                    }

                    if ((item.reval_txn_status === 1 || item.reval_txn_status === 3) && item.scrutiny === 1) {
                        newScrutinyItems.push({
                            courseCode: item.coursecd,
                            courseName: item.course,
                            courseid: item.courseid
                        });

                        totalAmountChange = totalAmountChange + SCRUTINY_COST

                    }

                    //  console.log(totalAmountChange);

                }


                if (hasStatus2 && newEcopyItems.length > 0) {


                    // setTableData(newEcopyItems);

                    setSteps([{
                        icon: 'fa-credit-card',
                        title: 'E-copy Payment',
                        status: true,
                    },
                    {
                        icon: 'fa-check-circle',
                        title: 'Ready for Despatch',
                        status: newEcopyItems.every(
                            data =>
                                data.ecopy_status === "verified" ||
                                data.ecopy_status === "despatched" ||
                                data.file_status === "verified"
                        )
                    },
                    {
                        icon: 'fa-truck',
                        title: 'Despatched',
                        status: newEcopyItems.every(
                            data =>
                                data.ecopy_status === "verified" ||
                                data.ecopy_status === "despatched" ||
                                data.file_status === "verified"
                        )
                    },
                    {
                        icon: 'fa-check-circle',
                        title: 'E-copy Completed',
                        status: newEcopyItems.map(data => data.file_status).every(status => status === "verified") && isecopyopen
                    }
                    ]);


                }
                else if (!hasStatus2 && newEcopyItems.length > 0) {

                    setSelectedEcopy(prevItems => [...prevItems, ...newEcopyItems]);
                }

                if (hasStatus3) {
                    setIsRevaluvationpaymentcompleted(true);

                    setSteps([{
                        icon: 'fa-credit-card',
                        title: 'Payment Completed',
                        status: true,
                    },

                    {
                        icon: 'fa-spinner',
                        title: 'In Progress',
                        status: newEcopyItems
                            // .map(data => .hj ) // optional, can directly use newRevaluationItems
                            .every(item =>
                                item.revaluation_result_published === "Progress" ||
                                item.revaluation_result_published === "Result_Published" ||
                                item.revaluation_result_published === "Completed"
                            )

                    },

                    {
                        icon: 'fa-graduation-cap ',
                        title: 'Completed',
                        //status: newRevaluationItems.map(data => data.revaluation_result_published).every(revaluation_result_published => revaluation_result_published == "Result_Published")
                        status: newEcopyItems.length > 0 &&
                            newEcopyItems.every(
                                item => item.revaluation_result_published === "Result_Published" ||
                                    item.revaluation_result_published === "Completed"
                            )

                    },
                    {
                        icon: 'fa-check-circle',
                        title: 'Result Published',
                        status: newEcopyItems.every(item =>
                            item.revaluation_result_published === "Result_Published"
                        )


                    }
                    ]);
                }


                if (!hasStatus3 && newRevaluationItems.length > 0) {

                    setSelectedRevaluation(prevItems => [...prevItems, ...newRevaluationItems]);
                }
                if (!hasStatus3 && newScrutinyItems.length > 0) {
                    setSelectedScrutiny(prevItems => [...prevItems, ...newScrutinyItems]);
                }


                // console.log(totalAmountChange);

                if (totalAmountChange > 0) {

                    setTotalAmount(prevAmount => {
                        const numericPrevAmount = Number(prevAmount) || 0;
                        return +(numericPrevAmount + totalAmountChange).toFixed(2);
                    });
                }




                http.get(`getActiveEventsForStudents`, { params: { event_id: 18, exam_id: selectedExamId[0]?.value } })
                    .then(response => {
                        if (response.data.http_status === 500) {
                            setTableData(mappedData);
                        }
                        else {
                            // Find if there's any matching exam with active status
                            const matchingEvent = response.data.find(event =>
                                event.exam_id == selectedExamId[0].value && event.status === 'active'
                            );

                            if (matchingEvent) {

                                setTableData(mappedData);

                            } else {
                                setTableData(newEcopyItems);
                            }
                        }
                    }).catch(error => {
                        // console.error("Error in get active events:", error);
                    });


                console.log("newRevaluationItems==", newRevaluationItems);
                console.log("newEcopyItems==", newEcopyItems);
                console.log("newScrutinyItems==", newScrutinyItems);

            }).catch(error => {

                const status = error.response?.data?.http_status;
                const message = error.response?.data?.message || "An error occurred";

                if (status === 500 || error.response?.data?.status_code === "ERR5") {
                    toast.error(message);
                } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
                    toast.error("Invalid Token");
                    setTimeout(() => navigate("/"), 5000);
                } else {
                    toast.error(message);
                }
            })
        }



    }, [selectedExamId]);

    // console.log(selectedScrutiny, selectedRevaluation, totalAmount);

    const handleCheckboxChange = (courseCode, courseName, courseid, isChecked) => {

        let newSelected;
        let amountChange = 0;


        newSelected = isChecked
            ? [...selectedEcopy, { courseCode, courseName, courseid }]
            : selectedEcopy.filter(item => item.courseCode !== courseCode);
        amountChange = isChecked ? ECOPY_COST : -ECOPY_COST;
        setSelectedEcopy(newSelected);

        setTotalAmount(prevAmount => {
            // Ensure we're working with numbers
            const numericPrevAmount = Number(prevAmount) || 0;
            const numericAmountChange = Number(amountChange) || 0;
            return numericPrevAmount + numericAmountChange;

        });
    };

    // console.log(selectedEcopy);

    const handleCheckboxChange2 = (item, courseCode, courseName, courseid, isChecked) => {

        let newSelected;
        let amountChange = 0;


        if (item === "revaluation") {
            newSelected = isChecked
                ? [...selectedRevaluation, { courseCode, courseName, courseid }]
                : selectedRevaluation.filter(item => item.courseCode !== courseCode);
            amountChange = isChecked ? REVALUVATION_COST : -REVALUVATION_COST;
            setSelectedRevaluation(newSelected);
        }
        if (item === "scrutiny") {
            newSelected = isChecked
                ? [...selectedScrutiny, { courseCode, courseName, courseid }]
                : selectedScrutiny.filter(item => item.courseCode !== courseCode);
            amountChange = isChecked ? SCRUTINY_COST : -SCRUTINY_COST;
            setSelectedScrutiny(newSelected);
        }

        setTotalAmount(prevAmount => {
            // Ensure we're working with numbers
            const numericPrevAmount = Number(prevAmount) || 0;
            const numericAmountChange = Number(amountChange) || 0;
            return numericPrevAmount + numericAmountChange;

        });
    };

    const handlefirstsubmit = () => {

        setFirstSubmit(!isFirstSubmit);

    }
    const handleCancel = () => {
        setFirstSubmit(!isFirstSubmit);
        // window.location.reload();
    }


    const handlePayment = (e) => {

        setLoading(true);
        e.preventDefault();

        const selectedRows = selectedEcopy.map(EcopyItem => {

            return {
                courseId: EcopyItem?.courseid,
                courseName: EcopyItem?.courseName,

            };
        });


        http.post(`Student/EcopyPaymentByStudent `, {

            examid: selectedExamId[0].value,
            courses: selectedRows,
            amount: totalAmount

        }).then(response => {

            setExamlink(response.data.reqParam);
            setUrl(response.data.url)

        }).catch(error => {

            setLoading(false);


            if (error.response?.data?.status_code === 'ERR9') {
                //console.log("Invalid Token");
                toast.error("Something went wrong");

            }
            else {
                toast.error("Something went wrong");
            }
        })

    }
    const handlePaymentReval = (e) => {

        setLoading(true);
        e.preventDefault();

        const selectedRows = Array.from(
            new Set([...selectedScrutiny, ...selectedRevaluation].map(item => item.courseCode))
        ).map(courseCode => {

            const scrutinyItem = selectedScrutiny.find(item => item.courseCode === courseCode);
            const revalItem = selectedRevaluation.find(item => item.courseCode === courseCode);

            return {
                courseId: scrutinyItem?.courseid || revalItem?.courseid,
                courseName: scrutinyItem?.courseName || revalItem?.courseName,
                scrutiny: scrutinyItem ? 1 : 0,
                revaluation: revalItem ? 1 : 0
            };
        });


        http.post(`Student/RVPaymentByStudent `, {

            examid: selectedExamId[0].value,
            courses: selectedRows,
            amount: totalAmount

        }).then(response => {

            setExamlink(response.data.reqParam);
            setUrl(response.data.url)

        }).catch(error => {

            setLoading(false);


            if (error.response?.data?.status_code === 'ERR9') {
                console.log("Invalid Token");
            }
            else {
                toast.error("Something went wrong");
            }
        })

    }



    useEffect(() => {

        if (examlink && url) {
            // Create a form element
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = url;
            form.id = 'frmpaymentaction';

            // Create input element
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'epay_req_params';
            input.value = examlink;
            input.id = 'epay_req_params';

            // Append input to form
            form.appendChild(input);

            // Append form to document body
            document.body.appendChild(form);

            // Submit the form
            form.submit();

            // Clean up - remove form after submission
            return () => {
                if (document.getElementById('frmpaymentaction')) {
                    document.body.removeChild(form);
                }
                setLoading(false);

            };
        }
    }, [examlink, url]);

    const generatePdf = async (courseid) => {
        setLoading(true);
        try {
            const response = await http.get('/Result/StudentEcopyProfileResultpdf', {
                params: {
                    examid: selectedExamId[0].value,
                    course_id: courseid
                },
                responseType: 'blob',
            });

            if (response && response.data) {
                // Create blob URL
                const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
                const pdfUrl = URL.createObjectURL(pdfBlob);

                setPdfUrl(pdfUrl);
                setShowPdfModal(true);
                setLoading(false);
            }
            else {
                toast.error('File not found');
            }
        } catch (error) {
            setLoading(false);

            if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
                toast.error("Invalid Token");
                setTimeout(() => {
                    navigate("/");
                }, 5000);

            }
            else if (error.response.status === 401) {
                toast.error("Invalid Token");
                setTimeout(() => {
                    navigate("/");
                }, 5000);

            }
            else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR47") {
                toast.error(error.response.data.message);
            }
            else if (error.response.status === 500) {
                toast.error("File not found");
            }
            else {
                // console.error('Error generating PDF:', error);
                toast.error('Error generating PDF');
            }
        }
    };
    const PDFViewer = ({ pdfUrl }) => {
        return (
            <iframe
                src={pdfUrl}
                width="100%"
                height="100%"
                style={{ border: 'none' }}
            />
        );
    };



    const downloadPdf = async (courseid) => {

        setLoading(true);
        try {
            const response = await http.get('/Result/StudentEcopyProfileResultpdf', {
                params: {
                    examid: selectedExamId[0].value,
                    course_id: courseid
                },
                responseType: 'blob',
            });

            if (response && response.data) {
                // Create a URL for the downloaded file
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;

                // Set the file name and download the PDF
                link.setAttribute('download', `ExamResult.pdf`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setLoading(false);
                return Promise.resolve('PDF generated successfully');
            }

        } catch (error) {
            setLoading(false);

            if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
                toast.error("Invalid Token");
                setTimeout(() => {
                    navigate("/");
                }, 5000);

            }
            else if (error.response.status === 401) {
                toast.error("Invalid Token");
                setTimeout(() => {
                    navigate("/");
                }, 5000);

            }
            else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR47") {
                toast.error(error.response.data.message);
            }
            else if (error.response.status === 500) {
                toast.error("File not found");
            }
            else {
                // console.error('Error generating PDF:', error);
                toast.error('Error generating PDF');
            }

            //toast.error('Error generating PDF');
        }
    }


    const [uniqueCourseCount, setUniqueCourseCount] = useState(0);

    useEffect(() => {
        const allCourses = [...selectedScrutiny, ...selectedRevaluation];

        // Use a Set to get unique course IDs
        const uniqueCourses = new Set(allCourses.map(course => course.courseid));

        setUniqueCourseCount(uniqueCourses.size);
    }, [selectedScrutiny, selectedRevaluation]);

    // console.log("uniqueCourseCount", uniqueCourseCount);


    // console.log(isecopyopen, ispaymentcompleted, isRevaluvationpaymentcompleted, activerevaluvation);
    // console.log(isecopyopen, ispaymentcompleted, isRevaluvationpaymentcompleted, activerevaluvation);

    const handleOpenScrutinyRemarkModal = (remark, courseCode) => {

        let parsedRemark;

        try {
            // Parse remark if it's a JSON string
            parsedRemark = typeof remark === 'string' ? JSON.parse(remark) : remark;
        } catch (error) {
            // console.error('Invalid JSON in remark:', remark);
            parsedRemark = [];
        }

        const soEntry = Array.isArray(parsedRemark)
            ? parsedRemark.find(entry => entry.user.includes('SO'))
            : null;

        // Get only the remark text, or fallback to 'No remark'
        const extractedRemark = soEntry ? soEntry.remark : 'No remark from SO';
        setScrutinyRemark(extractedRemark);
        setScrutinyCourseCode(courseCode);
        setScrutinyModalOpen(true);
    };

    const [showModal, setShowModal] = useState(false);
    const [revaluationData, setRevaluationData] = useState([]);
    const [scrutinyData, setScrutinyData] = useState([]);
    const [publishedCourses, setPublishedCourses] = useState([]);

    useEffect(() => {
        const fetchPreviousMarks = () => {

            http.get('/Student/getStudentRevaluationScrutinyResults', {

                params: {
                    examid: examId
                },

            }).then(response => {

                const reval = response.data?.revaluation || [];
                const scrut = response.data?.scrutiny || [];

                setRevaluationData(reval);
                setScrutinyData(scrut);

                // Combine both results for table display
                const mergedData = [...reval].map(item => ({
                    course_code: item.course_code || "-",
                    course_name: item.course_name || "-",
                    ESE_previous: item.ESE_old || "-",
                    ESE_scrutiny: item.scrutiny_new || "-",
                    ESE_revaluation: item.ESE_new || "-",
                    ESE_revised: item.ESE_new || "-", // Revised = latest reval
                    max_mark: item.max_mark || "-",
                    result_previous: item.overall_result_old || "-",
                    result_revised: item.overall_result_new || "-",
                    status: item.reval_mark_change_status || "-"
                }));

                setPublishedCourses(mergedData);

                // If either array has data, auto-open modal
                //if (reval.length > 0 || scrut.length > 0) {
                //setShowModal(true);
                //}



            }).catch(error => {

                setLoading(false);

                if (error.response?.data?.status_code === 'ERR9') {
                    //console.log("Invalid Token");
                    toast.error("Invalid Token");
                    setTimeout(() => {
                        navigate("/");
                    }, 5000);
                }

                else if (error.response?.data?.status_code !== 'ERR5') {
                    toast.error("Something went wrong");
                }
            });
        };

        if (examId != false) {
            fetchPreviousMarks();
        }
    }, [examId]);




    const handleNewResultView = () => {
        setShowModal(true);
    }


    return (
        <>
            <StudentTemplate>
                <ToastContainer />
                {loading ? (

                    // <div className="container-fluid">
                    //     <div className="row justify-content-center align-items-center">
                    //         <div className="col-sm-12">
                    //             <div className="card h-100">
                    //                 <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                    //                     <div className="containeranimate">
                    //                         <div className="dot"></div>
                    //                         <div className="dot"></div>
                    //                         <div className="dot"></div>
                    //                         <div className="dot"></div>
                    //                         <div className="dot"></div>
                    //                         <div className="dot"></div>
                    //                         <div className="dot"></div>
                    //                         <div className="dot"></div>
                    //                     </div>
                    //                 </div>
                    //             </div>
                    //         </div>
                    //     </div>
                    // </div>

                    <Loader />
                ) : (

                    <>


                        {ispaymentcompleted && (
                            <>
                                <div className="d-none d-md-block"> {/* Show only on desktop devices */}
                                    <div className="mt-1 mb-3 p-2">
                                        <div className="card p-4">


                                            <ul className="progress-steps">
                                                {steps.map((step, index) => (
                                                    <li
                                                        className={`step ${step.status === true ? "completed" : ""}`}
                                                        key={index}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                    >
                                                        <div className="step-content">
                                                            <span className="step-circle">
                                                                <i className={`fas ${step.icon}`}></i>
                                                            </span>
                                                            <div className="step-info mt-2 text-center">
                                                                <h6 className="mb-1">{step.title}</h6>


                                                            </div>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>



                                        </div>

                                    </div>
                                </div>

                                <div className="d-md-none"> {/* Show only on mobile devices */}
                                    <div className="mt-1 p-2">
                                        <div className="card " >
                                            <div className="accordion" id="statusAccordion" >
                                                <div className="accordion-item" style={{ borderRadius: "15px", padding: "0px", margin: "0px" }} >
                                                    <h2 className="accordion-header mobile" id="statusHeading" >
                                                        <button
                                                            className="accordion-button"
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target="#statusCollapse"
                                                            aria-expanded="true"
                                                            aria-controls="statusCollapse"
                                                        >
                                                            {steps && steps.length > 0 && (() => {
                                                                const completedStep = steps.slice().reverse().find(step => step.status === true);
                                                                if (completedStep) {
                                                                    return (
                                                                        <>
                                                                            <li
                                                                                className="step completed2 mobile"
                                                                                data-bs-toggle="tooltip"
                                                                                data-bs-placement="top"
                                                                            >
                                                                                <div className="step-content">
                                                                                    <span className="step-circle ">
                                                                                        <i className={`fas ${completedStep.icon}`}></i>
                                                                                    </span>
                                                                                    <div className="step-info mt-2 text-center">
                                                                                        <h6 className="mb-1">{completedStep.title}&nbsp;&nbsp; <i className="fas fa-chevron-right"></i></h6>
                                                                                    </div>




                                                                                </div>
                                                                            </li>
                                                                        </>
                                                                    );
                                                                }
                                                                return null;
                                                            })()}

                                                        </button>

                                                    </h2>



                                                    <div
                                                        id="statusCollapse"
                                                        className="accordion-collapse collapse"
                                                        aria-labelledby="statusHeading"
                                                        data-bs-parent="#statusAccordion"
                                                    >
                                                        <div className="accordion-body">
                                                            <hr width="100%" color="black" style={{ height: "1px" }} className='p-0 mb-1 mt-0'></hr>
                                                            <ul className="progress-steps">
                                                                {steps.map((step, index) => (
                                                                    <li
                                                                        className={`step ${step.status === true ? "completed" : ""}`}
                                                                        key={index}
                                                                        data-bs-toggle="tooltip"
                                                                        data-bs-placement="top"
                                                                    >
                                                                        <div className="step-content">
                                                                            <span className="step-circle">
                                                                                <i className={`fas ${step.icon}`}></i>
                                                                            </span>
                                                                            <div className="step-info mt-2 text-center">
                                                                                <h6 className="mb-1">{step.title}</h6>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                ))}
                                                            </ul>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}



                        {/* <div className={containerClass}> */}
                        <div className="container ">


                            <div className="row justify-content-center">
                                <div className="col-md-12 col-lg-12">
                                    <div className="card shadow-lg border-0">
                                        <div className={`card-body  ${isFirstSubmit ? 'blur-background' : ''}`}>
                                            <div className={isModalOpen ? 'blur-background' : ''}>
                                                <div className={showModal ? 'blur-background' : ''}>
                                                    <div className={scrutinyModalOpen ? 'blur-background' : ''}>

                                                        <div className="card-header">
                                                            <div className="py-3 st-hed-pb d-flex justify-content-center align-items-center text-center mobile">
                                                                <h4 className='mobile'>
                                                                    Answer Script E-copy/Revaluation/Scrutiny Request</h4>

                                                            </div>
                                                        </div>

                                                        <div>
                                                            <div className="">
                                                                <Select
                                                                    maxMenuHeight={200}
                                                                    menuPlacement="auto"
                                                                    id="exam_id"
                                                                    name="exam_id"
                                                                    className="basic-select"
                                                                    classNamePrefix="select"
                                                                    onChange={handleChangeExam}
                                                                    options={getexamData.map(exam => ({
                                                                        value: exam.examid,
                                                                        label: exam.examtitle,
                                                                    }))}
                                                                    value={selectedExamId.length > 0 ? selectedExamId.map(exam => ({
                                                                        value: exam.value,
                                                                        label: exam.label,
                                                                    })
                                                                    ) : []}

                                                                    placeholder="Select an exam..."
                                                                />
                                                            </div>





                                                            <div className="container p-0 m-0">
                                                                <div className="card shadow-sm" style={{ marginBottom: '10px' }}>
                                                                    {selectedEcopy.length > 0 ? (
                                                                        <div className="card-header bg-white">
                                                                            <div className="d-flex justify-content-between align-items-center"
                                                                                role="button"
                                                                                onClick={() => setIsExpanded(!isExpanded)} // You'll need to add this state
                                                                            >
                                                                                <div>

                                                                                    <h5 className="mb-0 mobilep">
                                                                                        {selectedEcopy.length} Selected &nbsp;&nbsp;&nbsp;

                                                                                        <i className={`bi bi-chevron-${isExpanded ? 'up' : 'down'}`}></i>
                                                                                    </h5>

                                                                                </div>
                                                                                <div>
                                                                                    {totalAmount > 0 ? (

                                                                                        <div className="d-flex ">
                                                                                            <button className="btn btn-success d-flex justify-content-between align-items-center mobilep"
                                                                                                onClick={(e) => {
                                                                                                    e.stopPropagation(); // Stop the event from bubbling up
                                                                                                    handlefirstsubmit();
                                                                                                }} >
                                                                                                <div className='mobilep'>Pay ₹ {totalAmount}</div>
                                                                                            </button>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <div className="d-flex ">
                                                                                            <button className="btn btn-success d-flex justify-content-between align-items-center mobilep" disabled>
                                                                                                <div className='mobilep'>Pay ₹ {totalAmount}</div>
                                                                                            </button>
                                                                                        </div>

                                                                                    )}


                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ) : (null)}




                                                                    {isExpanded && (
                                                                        <div className="card-body p-0 m-0">
                                                                            {selectedEcopy.length > 0 ? (
                                                                                <>
                                                                                    {selectedEcopy.map((course, index) => (
                                                                                        <div key={index} className="card mb-2 p-1 m-1">
                                                                                            <div className="card-body d-flex justify-content-between align-items-center py-2">
                                                                                                <div>
                                                                                                    <h6 className="mb-1 mobilep">{course.courseCode} - {course.courseName}</h6>
                                                                                                    <span className="badge bg-primary" style={{ fontSize: '0.65rem' }}>E-Copy</span>
                                                                                                </div>
                                                                                                <div className="d-flex align-items-center">
                                                                                                    <span className="h6 mb-0 me-3 mobilep">₹{ECOPY_COST}</span>
                                                                                                    <button className="btn btn-outline-danger btn-sm rounded-pill px-2"
                                                                                                        onClick={(e) => handleCheckboxChange(course.courseCode, course.courseName, course.courseid, false)}>
                                                                                                        <i className="bi bi-x"></i>
                                                                                                    </button>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    ))}


                                                                                </>
                                                                            ) : (
                                                                                <div className="text-center p-4">
                                                                                    <i style={{ color: "red" }} className="bi bi-info-circle me-2"></i>No data available
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )}


                                                                </div>
                                                            </div>

                                                            <div className="container m-0 p-0">
                                                                <div className="card shadow-sm">
                                                                    {(selectedScrutiny.length > 0 || selectedRevaluation.length > 0) ? (
                                                                        <div className="card-header bg-white">
                                                                            <div className="d-flex justify-content-between align-items-center"
                                                                                role="button"
                                                                                onClick={() => setIsReExpanded(!isReExpanded)} // You'll need to add this state
                                                                            >
                                                                                <div>

                                                                                    <h5 className="mb-0 mobilep">
                                                                                        {selectedScrutiny.length + selectedRevaluation.length} Selected &nbsp;&nbsp;&nbsp;

                                                                                        <i className={`bi bi-chevron-${isReExpanded ? 'up' : 'down'}`}></i>
                                                                                    </h5>

                                                                                </div>
                                                                                <div>
                                                                                    {totalAmount > 0 ? (

                                                                                        <div className="d-flex ">
                                                                                            <button className="btn btn-success d-flex justify-content-between align-items-center mobilep"
                                                                                                onClick={(e) => {
                                                                                                    e.stopPropagation(); // Stop the event from bubbling up
                                                                                                    handlefirstsubmit();
                                                                                                }}
                                                                                            >
                                                                                                <div className='mobilep'>Pay ₹ {totalAmount}</div>
                                                                                            </button>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <div className="d-flex ">
                                                                                            <button className="btn btn-success d-flex justify-content-between align-items-center mobilep" disabled>
                                                                                                <div className='mobilep'>Pay ₹ {totalAmount}</div>
                                                                                            </button>
                                                                                        </div>

                                                                                    )}


                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ) : (null)}

                                                                    {isReExpanded && (
                                                                        <div className="card-body p-0 m-0">
                                                                            {(selectedScrutiny.length > 0 || selectedRevaluation.length > 0) ? (
                                                                                <>
                                                                                    {selectedScrutiny.map((course, index) => (
                                                                                        <div key={index} className="card mb-2 p-1 m-1">
                                                                                            <div className="card-body d-flex justify-content-between align-items-center py-2">
                                                                                                <div>
                                                                                                    <h6 className="mb-1 mobilep">{course.courseCode} - {course.courseName}</h6>
                                                                                                    <span className="badge bg-primary" style={{ fontSize: '0.65rem' }}>Scrutiny</span>
                                                                                                </div>
                                                                                                <div className="d-flex align-items-center">
                                                                                                    <span className="h6 mb-0 me-3 mobilep">₹{SCRUTINY_COST}</span>
                                                                                                    <button className="btn btn-outline-danger btn-sm rounded-pill px-2"
                                                                                                        onClick={(e) => handleCheckboxChange2("scrutiny", course.courseCode, course.courseName, course.courseid, false)}>
                                                                                                        <i className="bi bi-x"></i>
                                                                                                    </button>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    ))}

                                                                                    {selectedRevaluation.map((course, index) => (
                                                                                        <div key={index} className="card mb-2 p-1 m-1 ">
                                                                                            <div className="card-body d-flex justify-content-between align-items-center py-2">
                                                                                                <div>
                                                                                                    <h6 className="mb-1 mobilep">{course.courseCode} - {course.courseName}</h6>
                                                                                                    <span className="badge bg-warning" style={{ fontSize: '0.65rem' }} >Revaluation</span>
                                                                                                </div>
                                                                                                <div className="d-flex align-items-center">
                                                                                                    <span className="h6 mb-0 me-3 mobilep">₹{REVALUVATION_COST}</span>
                                                                                                    <button className="btn btn-outline-danger btn-sm rounded-pill px-2"
                                                                                                        onClick={(e) => handleCheckboxChange2("revaluation", course.courseCode, course.courseName, course.courseid, false)}>
                                                                                                        <i className="bi bi-x"></i>
                                                                                                    </button>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    ))}
                                                                                </>
                                                                            ) : (
                                                                                <div className="text-center p-4 mobile1">
                                                                                    <i style={{ color: "red" }} className="bi bi-info-circle me-2"></i>No data available
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )}

                                                                </div>
                                                            </div>

                                                            {/* Button row */}
                                                            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "15px" }}>
                                                                {(publishedCourses.length > 0 || revaluationData.length > 0 || scrutinyData.length > 0) && (
                                                                    <button
                                                                        className="btn blink-btn btn-success btn-sm fw-bold shadow"
                                                                        //onClick={() => setShowModal(true)}
                                                                        onClick={handleNewResultView}
                                                                    >
                                                                        <i className="bi bi-bell-fill me-2"></i>
                                                                        View Previous Marks
                                                                    </button>
                                                                )}
                                                            </div>
                                                            <div className="table-responsive">



                                                                {Array.isArray(tableData) && tableData.length > 0 ? (
                                                                    // <div className="st-bx-bod ">

                                                                    <table className="table table-hover align-middle  table-bordered table-striped table-bordered" style={{ border: "1px solid #2324244f" }}>
                                                                        <thead class="table-dark" style={{ height: "50px" }}>
                                                                            <tr className='bg-primary'>
                                                                                <th scope="col" style={{ border: "1px solid #dee2e6", width: "200px", textAlign: "center", verticalAlign: "middle" }}>Course </th>
                                                                                <th scope="col" style={{ border: "1px solid #dee2e6", width: "70px", textAlign: "center", verticalAlign: "middle" }}>Credits</th>
                                                                                <th scope="col" style={{ border: "1px solid #dee2e6", width: "70px", textAlign: "center", verticalAlign: "middle" }}>ESE</th>
                                                                                <th scope="col" style={{ border: "1px solid #dee2e6", width: "70px", textAlign: "center", verticalAlign: "middle" }}>ESE Max</th>
                                                                                {/* <th scope="col" style={{ border: "1px solid #dee2e6", width: "70px", textAlign: "center", verticalAlign: "middle" }}>Grade</th> */}
                                                                                <th scope="col" style={{ border: "1px solid #dee2e6", width: "100px", textAlign: "center", verticalAlign: "middle" }}>Overall Course Result</th>


                                                                                {ispaymentcompleted && activerevaluvation ? (
                                                                                    <>
                                                                                        <th scope="col" style={{ border: "1px solid #dee2e6", width: "100px", textAlign: "center", verticalAlign: "middle" }}>Scrutiny</th>
                                                                                        <th scope="col" style={{ border: "1px solid #dee2e6", width: "100px", textAlign: "center", verticalAlign: "middle" }}>Revaluation</th>
                                                                                    </>
                                                                                ) : ispaymentcompleted && !activerevaluvation ? (
                                                                                    <th scope="col" style={{ border: "1px solid #dee2e6", width: "100px", textAlign: "center", verticalAlign: "middle" }}>E-Paper</th>
                                                                                ) : !ispaymentcompleted && (
                                                                                    <th scope="col" style={{ border: "1px solid #dee2e6", width: "100px", textAlign: "center", verticalAlign: "middle" }}>E-Paper</th>
                                                                                )}

                                                                                {ispaymentcompleted && isecopyopen && (
                                                                                    <>
                                                                                        <th scope="col" style={{ border: "1px solid #dee2e6", width: "100px", textAlign: "center", verticalAlign: "middle" }}>Action</th>

                                                                                    </>
                                                                                )}

                                                                                {isRevaluvationpaymentcompleted && (
                                                                                    <>
                                                                                        <th scope="col" style={{ border: "1px solid #dee2e6", width: "100px", textAlign: "center", verticalAlign: "middle" }}>Status</th>

                                                                                    </>
                                                                                )}



                                                                            </tr>
                                                                        </thead>
                                                                        <tbody className='table-bordered text-center'>

                                                                            {tableData.map((course, index) => (
                                                                                <tr key={index} className="course-row text-center" >
                                                                                    <td data-label="Course" style={{ border: "1px solid #111111", verticalAlign: "middle" }}>{course.coursecd} - {course.course} <br />
                                                                                        {course.revaluation === 1 ? <span className="badge bg-primary">Revaluation</span> : null} <br />
                                                                                        {course.scrutiny === 1 ? <span className="badge bg-primary">Scrutiny</span> : null}
                                                                                    </td>
                                                                                    <td data-label="Credits" style={{ border: "1px solid #111111", textAlign: "center", verticalAlign: "middle" }}>{course.credits}</td>
                                                                                    <td data-label="ESE" style={{ border: "1px solid #111111", textAlign: "center", verticalAlign: "middle" }}>{course.theory.ese} <br />

                                                                                        {course.revaluation_result_published === 'Result_Published' && (
                                                                                            <span className="badge bg-warning text-dark" style={{ fontSize: "0.65rem" }}>Revised</span>
                                                                                        )}</td>
                                                                                    <td data-label="ESE Max" style={{ border: "1px solid #111111", textAlign: "center", verticalAlign: "middle" }}>{course.theory.eseMax} <br />
                                                                                    </td>
                                                                                    {/* <td data-label="Grade" style={{ border: "1px solid #111111", textAlign: "center", verticalAlign: "middle" }}>{course.grade}</td> */}
                                                                                    <td data-label="Overall Result" style={{ border: "1px solid #111111", textAlign: "center", verticalAlign: "middle", color: course.overallResult === "Pass" ? "green" : "red" }}>
                                                                                        <b>{course.overallResult}</b>
                                                                                    </td>


                                                                                    {!ispaymentcompleted ? (
                                                                                        <td data-label="E-Copy" style={{ border: "1px solid #dee2e6", textAlign: "center", verticalAlign: "middle" }}>
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                id={`scrutiny-${index}`}
                                                                                                checked={selectedEcopy.some(item => item.courseCode === course.coursecd)}
                                                                                                onChange={(e) => handleCheckboxChange(course.coursecd, course.course, course.courseid, e.target.checked)}
                                                                                            />
                                                                                        </td>
                                                                                    ) : ispaymentcompleted && activerevaluvation ? (
                                                                                        <>
                                                                                            {/* new file status checking code added */}
                                                                                            {(course.reval_txn_status === "-" || course.reval_txn_status === 1 || course.reval_txn_status === 3 || course.reval_txn_status === 0) && (course.file_status === 'verified') ? (

                                                                                                <>
                                                                                                    <td data-label="Scrutiny" style={{ border: "1px solid #dee2e6", textAlign: "center", verticalAlign: "middle" }}>
                                                                                                        <input
                                                                                                            type="checkbox"
                                                                                                            id={`scrutiny-${index}`}
                                                                                                            checked={selectedScrutiny.some(item => item.courseCode === course.coursecd)}
                                                                                                            onChange={(e) => handleCheckboxChange2("scrutiny", course.coursecd, course.course, course.courseid, e.target.checked)}
                                                                                                        />
                                                                                                    </td>
                                                                                                    <td data-label="Revaluation" style={{ border: "1px solid #dee2e6", textAlign: "center", verticalAlign: "middle" }}>
                                                                                                        <input
                                                                                                            type="checkbox"
                                                                                                            id={`revaluation-${index}`}
                                                                                                            checked={selectedRevaluation.some(item => item.courseCode === course.coursecd)}
                                                                                                            onChange={(e) => handleCheckboxChange2("revaluation", course.coursecd, course.course, course.courseid, e.target.checked)}
                                                                                                        />
                                                                                                    </td>
                                                                                                </>


                                                                                            ) : (
                                                                                                <>
                                                                                                    <td>
                                                                                                        <ul className="action d-flex justify-content-center">
                                                                                                            <li className="view p-1 hide-in-mobile">
                                                                                                                {course.scrutiny === 1 ? (
                                                                                                                    <i className="bi bi-check-circle-fill text-success fs-5"></i>
                                                                                                                ) : (
                                                                                                                    <i className="bi bi-dash-circle-fill text-secondary fs-5"></i>
                                                                                                                )}

                                                                                                            </li>

                                                                                                        </ul>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <ul className="action d-flex justify-content-center">
                                                                                                            <li className="view p-1 hide-in-mobile">
                                                                                                                {course.revaluation === 1 ? (
                                                                                                                    <i className="bi bi-check-circle-fill text-success fs-5"></i>
                                                                                                                ) : (
                                                                                                                    <i className="bi bi-dash-circle-fill text-secondary fs-5"></i>
                                                                                                                )}
                                                                                                            </li>

                                                                                                        </ul>
                                                                                                    </td>
                                                                                                </>
                                                                                            )}
                                                                                        </>
                                                                                    ) : ispaymentcompleted && !activerevaluvation && (
                                                                                        <td data-label="E-Copy" style={{ border: "1px solid #dee2e6", textAlign: "center", verticalAlign: "middle" }}>
                                                                                            {course.txn_status == 2 ? (
                                                                                                <span className="badge bg-lbl-success">
                                                                                                    {course.file_status === 'uploaded' || course.file_status === "reverted" || course.file_status === "forwarded" ? "Processing" :
                                                                                                        course.file_status === "verified" ? "File Verified" :
                                                                                                            course.ecopy_status === "verified" ? "Ready for Despatch" :
                                                                                                                course.ecopy_status === "despatched" ? "Despatched" :
                                                                                                                    "Paid"}
                                                                                                </span>
                                                                                            ) : (course.txn_status === "-" || course.txn_status === 1 || course.txn_status === 3) && (

                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    id={`scrutiny-${index}`}
                                                                                                    checked={selectedEcopy.some(item => item.courseCode === course.coursecd)}
                                                                                                    onChange={(e) => handleCheckboxChange(course.coursecd, course.course, course.courseid, e.target.checked)}
                                                                                                />
                                                                                            )}
                                                                                        </td>
                                                                                    )}



                                                                                    {ispaymentcompleted && course.file_status === "verified" && isecopyopen ? (
                                                                                        <td>
                                                                                            <ul className="action d-flex justify-content-center">
                                                                                                <li className="view p-1 hide-in-mobile">
                                                                                                    <span className="icon-eye" style={{ cursor: "pointer", color: "blue" }} onClick={() => generatePdf(course.courseid)}></span>
                                                                                                </li>
                                                                                                <li className="view p-1">
                                                                                                    <span className="icon-download" style={{ cursor: "pointer", color: "green" }} onClick={() => downloadPdf(course.courseid)}  ></span>
                                                                                                </li>
                                                                                            </ul>
                                                                                        </td>
                                                                                    ) : ispaymentcompleted && isecopyopen && (
                                                                                        <td>
                                                                                            <ul className="action d-flex justify-content-center">
                                                                                                <li className="view p-1 hide-in-mobile">
                                                                                                    --
                                                                                                </li>

                                                                                            </ul>
                                                                                        </td>
                                                                                    )}

                                                                                    {isRevaluvationpaymentcompleted && (
                                                                                        course.reval_txn_status == 2 ? (
                                                                                            <>
                                                                                                <td data-label="status" style={{ border: "1px solid #dee2e6", textAlign: "center", verticalAlign: "middle" }}>
                                                                                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "5px" }}>
                                                                                                        {course.scrutiny === 1 && (
                                                                                                            <span className="badge" title="Scrutiny Info" onTouchStart={() => handleOpenModal(course.courseid, course.coursecd, course.course)}
                                                                                                                onClick={() => handleOpenModal(course.courseid, course.coursecd, course.course)}
                                                                                                                style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                                                                                <i className="bi bi-chat-square-text-fill info-icon-stl"></i>
                                                                                                            </span>
                                                                                                        )}
                                                                                                        {course.scrutiny == 1 && (
                                                                                                            <span className="badge bg-lbl-success">Scrutiny Applied</span>
                                                                                                        )}
                                                                                                        {course.revaluation == 1 && course.revaluation_result_published != 'Result_Published' && (
                                                                                                            <span className="badge bg-lbl-success mt-1">Revaluation Applied</span>
                                                                                                        )}
                                                                                                        {(course.scrutiny == 1 && course.scrutiny_status == 2) && (
                                                                                                            <span
                                                                                                                className="badge bg-danger mt-1 rej-badge-hover"
                                                                                                                style={{ cursor: "pointer" }}
                                                                                                                title="Click to view remark"
                                                                                                                onClick={() => handleOpenScrutinyRemarkModal(course.scrutiny_remarks, course.coursecd)}
                                                                                                            >
                                                                                                                Scrutiny Rejected
                                                                                                            </span>
                                                                                                        )}

                                                                                                        {((course.scrutiny === 1 || course.revaluation === 1) && course.revaluation_result_published === 'Result_Published') && (

                                                                                                            <span className="badge bg-lbl-success mt-1">
                                                                                                                <i className="bi bi-bell-fill me-1"></i>

                                                                                                                Result Published</span>
                                                                                                        )}

                                                                                                    </div>
                                                                                                </td>
                                                                                            </>
                                                                                        ) : (
                                                                                            <td>
                                                                                                <ul className="action d-flex justify-content-center">
                                                                                                    <li className="view p-1 hide-in-mobile">
                                                                                                        --
                                                                                                    </li>

                                                                                                </ul>
                                                                                            </td>
                                                                                        )
                                                                                    )}




                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>


                                                                ) : (
                                                                    null
                                                                )}
                                                            </div>

                                                            {publishedCourses.length > 0 && (
                                                                <div className="txt-aln">

                                                                    <p className="text-muted mt-2" style={{ fontSize: "0.85rem" }}>
                                                                        <span className="badge bg-warning text-dark me-1 m-10" style={{ fontSize: "0.65rem" }}>Revised</span> marks indicate updated marks after scrutiny/revaluation.
                                                                        You can view the old marks by clicking <strong>‘View Previous Marks’</strong>.
                                                                    </p>
                                                                </div>

                                                            )}

                                                            {Array.isArray(tableData) && tableData.length > 0 && (
                                                                <div className="txt-aln">
                                                                    <p style={{ fontSize: "12px" }}><span className="text-danger m-10 txt-aln-jst">* Note:-The scrutiny application will be successfully submitted only after the completion of payment and the raising of scrutiny complaints
                                                                    </span>
                                                                    </p>
                                                                </div>
                                                            )}

                                                        </div>




                                                        <div className="text-center m-t-20">

                                                            <div className="text-center mobile">
                                                                <h6 style={{ color: 'blue' }}>
                                                                    <a href="https://ugpapi.mgu.ac.in/ugp/docs/E_Copy_Request-USER_GUIDE__3_.pdf" target="_blank" rel="noopener noreferrer">
                                                                        E-Copy Request User Guide
                                                                    </a>
                                                                </h6>
                                                            </div>

                                                            <h6 style={{ color: 'red' }} className='mobilep'>For Payment related Enquiries : 0481-2733626,0481-2733580</h6>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                        {scrutinyModalOpen && (
                                            <div className="modal fade show" style={{ display: 'block' }}>
                                                <div className="modal-dialog modal-dialog-centered">
                                                    <div className="modal-content">
                                                        <div className="modal-header">
                                                            <h5 className="modal-title">Scrutiny Rejected - {scrutinyCourseCode}</h5>
                                                            <button type="button" className="btn-close" onClick={() => setScrutinyModalOpen(false)}></button>
                                                        </div>
                                                        <div className="modal-body">
                                                            <p style={{ color: 'red' }}>{scrutinyRemark || "No remark provided."}</p>
                                                        </div>
                                                        <div className="modal-footer">
                                                            <button className="btn btn-secondary" onClick={() => setScrutinyModalOpen(false)}>Close</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {showModal && (
                                            <div
                                                className="modal fade show"
                                                style={{
                                                    display: 'block',
                                                    backgroundColor: 'rgba(0,0,0,0.5)',
                                                    position: 'fixed',
                                                    top: 0,
                                                    left: 0,
                                                    right: 0,
                                                    bottom: 0,
                                                    zIndex: 1050,
                                                    overflow: 'auto'
                                                }}
                                                onClick={() => setShowModal(false)}
                                                role="dialog"
                                                aria-modal="true"
                                            >
                                                <div
                                                    className="modal-dialog modal-dialog-centered modal-lg"
                                                    style={{ maxWidth: '100%' }}
                                                    onClick={(e) => e.stopPropagation()}
                                                >
                                                    <div className="container-fluid">
                                                        <div className="row justify-content-center">
                                                            <div className="col-12 col-md-10 col-xl-8" style={{ display: 'contents' }}>
                                                                <div className="modal-content shadow-lg activity-scroll-container activity-scroll-bar-container" style={{ width: '80%' }}>
                                                                    <div className="modal-header bg-primary text-white">
                                                                        <h5 className="modal-title">Previous Marks</h5>
                                                                        <button
                                                                            type="button"
                                                                            className="btn-close btn-close-white"
                                                                            onClick={() => setShowModal(false)}
                                                                            aria-label="Close"
                                                                        ></button>
                                                                    </div>
                                                                    <div className="modal-body p-0">
                                                                        <div className="table-responsive">

                                                                            {/* Revaluation Table */}

                                                                            {revaluationData.length > 0 && (
                                                                                <table className="table table-bordered table-hover mb-0">
                                                                                    <thead className="table-primary">

                                                                                        <tr style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                                                                            <th rowSpan="2" className="align-middle">Course Name</th>
                                                                                            <th colSpan="4" className="text-center">ESE</th>
                                                                                            <th rowSpan="2" className="text-center">ESE Max</th>
                                                                                            {/* <th colSpan="2" className="text-center">Grade</th> */}
                                                                                            <th colSpan="2" className="text-center">Result</th>
                                                                                            <th rowSpan="2" className="text-center">Status</th>
                                                                                        </tr>
                                                                                        <tr style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                                                                            <th>Previous</th>
                                                                                            <th>Scrutiny</th>
                                                                                            <th>Revaluation</th>
                                                                                            <th>Revised</th>
                                                                                            <th>Previous</th>
                                                                                            <th>Revised</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {revaluationData.map((course, i) => (
                                                                                            <tr key={i} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                                                                                <td className="text-start">{course.course_code} - {course.course_name}</td>
                                                                                                {/* ESE Columns */}
                                                                                                <td>{course.ESE_old || "-"}</td>
                                                                                                <td>{course.scrutiny === 1 ? course.scrutiny_new : "-"}</td>
                                                                                                <td>{course.revaluation === 1 ? course.ESE_new : "-"}</td>
                                                                                                <td>{course.ESE_new || "-"}</td>

                                                                                                {/* ESE Max */}
                                                                                                <td>{course.max_mark || "-"}</td>

                                                                                                {/* Result Columns */}
                                                                                                <td>{course.overall_result_old || "-"}</td>
                                                                                                <td style={{ color: 'green' }}>{course.overall_result_new || "-"}</td>
                                                                                                {/* Status */}
                                                                                                <td>
                                                                                                    {course.reval_mark_change_status === "Mark Changed" ? (
                                                                                                        <span className="badge bg-success">
                                                                                                            {course.reval_mark_change_status}
                                                                                                        </span>
                                                                                                    ) : (
                                                                                                        <span className="badge bg-warning text-dark me-1">
                                                                                                            {course.reval_mark_change_status || "-"}
                                                                                                        </span>
                                                                                                    )}
                                                                                                </td>

                                                                                            </tr>
                                                                                        ))}
                                                                                    </tbody>
                                                                                </table>
                                                                            )}

                                                                        </div>

                                                                    </div>
                                                                    <div className="modal-footer">
                                                                        <button
                                                                            type="button"
                                                                            className="close-btn-stl"
                                                                            onClick={() => setShowModal(false)}
                                                                        >
                                                                            Close
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {isModalOpen && (
                                            <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-modal="true">
                                                <div className="modal-dialog modal-dialog-centered" role="document">
                                                    <div className="modal-content">
                                                        <div className="modal-header">
                                                            <div className="modal-header-stl text-center">
                                                                <h6 className="modal-title" style={{ marginBottom: "5px", lineHeight: "1.2" }}>
                                                                    <b>Scrutiny Complaints</b>
                                                                </h6>
                                                                <p className="modal-title" style={{ marginTop: "0", lineHeight: "1.2" }}>
                                                                    <b>{selectedCourseCode} - {selectedCourseName}</b>
                                                                </p>

                                                            </div>
                                                            {/* <button type="button" className="close" onClick={handleCloseModal}> 
                                                                                                            <span>&times;</span>
                                                                                                        </button>*/}
                                                        </div>
                                                        <div className="modal-body">
                                                            <table className="table table-bordered">
                                                                <tbody style={{ textAlign: 'left' }}>
                                                                    {remarkOfStudentData.length > 0 && remarkOfStudentData[0] ? (
                                                                        <>
                                                                            <tr><td><b>Issue in Marks Addition</b></td><td>:</td><td>{remarkOfStudentData[0]?.mark_not_added
                                                                                ? (remarkOfStudentData[0].mark_not_added === "yes" ? "Yes" : "No")
                                                                                : "N/A"}</td></tr>
                                                                            <tr><td><b>Questions Not Evaluated</b></td><td>:</td><td>{remarkOfStudentData[0]?.questions_not_valued?.length ? remarkOfStudentData[0].questions_not_valued.join(", ") : "N/A"}</td></tr>
                                                                            <tr><td><b>Additional Description</b></td><td>:</td><td>{remarkOfStudentData[0].additional_description || "N/A"}</td></tr>
                                                                            <tr><td><b>Applied Date</b></td><td>:</td><td>{new Date(remarkOfStudentData[0].applied_date).toLocaleDateString("en-GB")}</td></tr>
                                                                        </>
                                                                    ) : (
                                                                        <tr>
                                                                            <td colSpan="3" style={{ textAlign: "center" }}>No Data Available</td>
                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div className="modal-footer">
                                                            <button type="button" className="close-btn-stl " onClick={handleCloseModal}>Close</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <div className={`modal fade ${isFirstSubmit ? 'show d-block' : ''}`} id="paymentConfirmationModal" tabIndex="-1" aria-labelledby="paymentConfirmationModalLabel" aria-hidden={!isFirstSubmit}>
                                            <div className="modal-dialog modal-dialog-centered">
                                                <div className="modal-content border rounded shadow">
                                                    <div className="modal-header bg-light border-bottom">
                                                        <div className="d-flex align-items-center">
                                                            <img src={logo} alt="Logo" style={{ width: '40px', height: '36px', marginRight: '10px' }} />
                                                            <h5 className="modal-title fw-bold m-0 text-balck" id="paymentConfirmationModalLabel" style={{ color: 'black' }}>Payment Confirmation</h5>
                                                        </div>
                                                        <button type="button" className="btn-close" onClick={handleCancel} aria-label="Close"></button>
                                                    </div>

                                                    <div className="modal-body">
                                                        <p className="text-center text-black fw-bold ">Are you sure you want to proceed to payment?</p>
                                                        {activerevaluvation && (
                                                            <div className="card mb-4">
                                                                <div className="card-header p-0 ">
                                                                    <h6 className="m-0 text-balck text-center">Application Summary</h6>
                                                                </div>

                                                                <div className="card-body p-0">
                                                                    <table className="table table-striped mb-0">
                                                                        <tbody>
                                                                            <tr>
                                                                                <th scope="row" className="w-75">Number of Courses Selected</th>
                                                                                <td>{uniqueCourseCount} ({tableData.length})</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <th scope="row">Scrutiny</th>
                                                                                <td>{selectedScrutiny.length}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <th scope="row">Revaluation</th>
                                                                                <td>{selectedRevaluation.length}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>

                                                            </div>
                                                        )}
                                                        {/* <div className="alert alert-secondary border">
                                                            <p className="mb-0"><strong>Important:</strong> This is a one-time application. Students must select all the courses they wish to include for E-copy/scrutiny/revaluation in this single attempt. No further modifications will be allowed beyond this step.</p>
                                                        </div> */}

                                                        {selectedScrutiny.length > 0 && (
                                                            <div className="alert alert-danger border">
                                                                <p className="mb-0"><strong>Note:</strong> The scrutiny application will be successfully submitted only after the completion of payment and the raising of scrutiny complaints.</p>
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="modal-footer bg-light border-top">
                                                        <button type="button" className="btn btn-secondary px-4" onClick={handleCancel}>Cancel</button>
                                                        {activerevaluvation ? (
                                                            <button type="button" className="btn btn-primary px-4" onClick={handlePaymentReval}>Proceed to Payment</button>
                                                        ) : (
                                                            <button type="button" className="btn btn-primary px-4" onClick={handlePayment}>Proceed to Payment</button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className={`modal ${showPdfModal ? 'show d-block' : ''}`}
                                            style={{
                                                position: 'fixed',
                                                top: 0,
                                                left: 0,
                                                width: '100vw',
                                                height: '100vh',
                                                backgroundColor: 'rgba(0,0,0,0.5)',
                                                zIndex: 1050
                                            }}
                                            tabIndex="-1"
                                            role="dialog"
                                        >
                                            <div style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                width: '100%',
                                                height: '100%',
                                                backgroundColor: 'white'
                                            }}>
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    padding: '10px 15px',
                                                    borderBottom: '1px solid #dee2e6',
                                                    backgroundColor: '#fff'
                                                }}>
                                                    <h5 className="modal-title mb-0">Document Viewer</h5>
                                                    <button
                                                        type="button"
                                                        className="btn-close"
                                                        onClick={() => {
                                                            setShowPdfModal(false);
                                                            if (pdfUrl) {
                                                                URL.revokeObjectURL(pdfUrl);
                                                                setPdfUrl(null);
                                                            }
                                                        }}
                                                        aria-label="Close"
                                                    ></button>
                                                </div>
                                                <div style={{
                                                    height: 'calc(100% - 60px)',
                                                    overflow: 'hidden'
                                                }}>
                                                    {pdfUrl && <PDFViewer pdfUrl={pdfUrl} />}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div >
                        {/* </div> */}




                    </>







                )}
            </StudentTemplate >
        </>


    );
};

export default StudentEPaperCopyview;
